import * as React from 'react'

import { SubMenuTabs } from '../../../components/SubMenu/SubMenuTabs'
import { CALENDAR_VIEW_LABELS, CalendarView, CalendarViewParam } from '../constants'
import { useCalendarRouter } from '../hooks/useCalendarRouter'

const MENU_TABS: Array<keyof typeof CALENDAR_VIEW_LABELS> = [
  CalendarView.Economic,
  CalendarView.Earnings,
  CalendarView.Dividends,
]

export function Navigation() {
  const {
    getCalendarLink,
    viewParams: { dateFrom },
    view: activeView,
  } = useCalendarRouter<
    CalendarView.Earnings | CalendarView.Economic | CalendarView.EconomicDetail | CalendarView.Dividends
  >()
  const menuItems = React.useMemo(
    () =>
      MENU_TABS.map((view) => ({
        label: CALENDAR_VIEW_LABELS[view],
        href: getCalendarLink({ view, params: { [CalendarViewParam.DateFrom]: dateFrom } }),
        isActive:
          activeView === view || (view === CalendarView.Economic && activeView.includes(CalendarView.EconomicDetail)),
        reloadDocument: true,
      })),
    [activeView, getCalendarLink, dateFrom]
  )

  return <SubMenuTabs size="xlarge" items={menuItems} />
}
